import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { Typography, Grid, Card, CardContent, Button } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import SaveIcon from '@material-ui/icons/Save';
import UpdateIcon from '@material-ui/icons/Update';
import Controls from '../controls/Controls';
import { useConstantsContext } from '../../context/constants_context';
import { useClientContext } from '../../context/client_context';
import { verificationState, baseUrl, accountType } from '../../utils/constants';

export default function BankingDetails() {
  const { banks, bankBranches } = useConstantsContext();
  const { clientRefId, currentClient, clientBankingDetails, setClientBankingDetails } =
    useClientContext();
  const [bankData, setBankData] = useState(null);

  const BankingDetailsSchema = Yup.object().shape({
    accountHolder: Yup.string()
      .min(2, 'Account name is too Short!')
      .max(50, 'Account name is too Long!')
      .required('Account name is required'),
    bankAccount: Yup.string()
      .min(2, 'Account number is too Short!')
      .max(50, 'Account number is too Long!')
      .required('Account # required'),
    bankRefId: Yup.string().required('Bank is required'),
    bankBranchRefId: Yup.string().required('Bank Branch is required'),
    verificationDate: Yup.date().required('Verification Date is required')
  });

  // const initialValue = {
  //   bankRefId: clientBankingDetails.bankRefId,
  //   bankBranchRefId: clientBankingDetails.bankBranchRefId,
  //   accountName: clientBankingDetails.accountName,
  //   bankAccount: clientBankingDetails.bankAccount,
  //   bankAccountType: clientBankingDetails.bankAccountType,
  //   verificationStatus: clientBankingDetails.verificationStatus,
  //   verificationDate: clientBankingDetails.verificationDate,
  //   lastResponseCode: clientBankingDetails.lastResponseCode,
  //   clientRefId
  // };

  // useEffect(() => {
  //   setBankData(initialValue);
  // }, []);

  const formik = useFormik({
    initialValues: clientBankingDetails,
    enableReinitialize: true,
    validationSchema: BankingDetailsSchema,
    onSubmit: (values) => {
      console.log('banking before that exe 2', values);
      handleFormUpdate(values);
    }
  });

  const handleFormUpdate = (e) => {
    e.clientRefId = clientRefId;
    saveBankingDetails(e);
  };

  const saveBankingDetails = (info) => {
    const jsonClient = [];
    jsonClient.push(info);
    console.log('banking details stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/savebankingdetails`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // setClientRefId(result.clientID);
          // setCurrentClient(result);
          <Alert variant="filled" severity="success">
            Client Saved Successfully!
          </Alert>;
        },
        (error) => {
          <Alert variant="filled" severity="error">
            Error in Saving Client!, {error}
          </Alert>;
        }
      );
  };
  // console.log('initial Bank formData values here', bankData);
  return (
    <Card>
      <CardContent>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate>
            <Typography variant="h6" gutterBottom>
              Banking Info...
            </Typography>
            <Grid
              container
              spacing={2}
              // direction="column"
              justifyContent="center"
              alignItems="center"
              // rowHeight={15}
            >
              <Grid item xs={6} container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={6} sm={4}>
                  <Controls.SelectJson name="bankRefId" label="Bank" options={banks} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.SelectJson
                    name="bankBranchRefId"
                    label="Bank Branch"
                    options={bankBranches}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={4} sm={4}>
                  <Controls.Input name="accountHolder" label="Account Holder" />
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Controls.Input name="bankAccount" label="Account Number" />
                </Grid>
              </Grid>
              <Grid
                item
                xs={6}
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                size="small"
              >
                <Grid item xs={6} sm={4}>
                  <Controls.SelectJson
                    name="bankAccountType"
                    label="Bank Account Type"
                    options={accountType}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.SelectJson
                    name="verificationStatus"
                    label="Verification Status"
                    options={verificationState}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={4} sm={4}>
                  <Controls.DateTime name="verificationDate" label="Verification Date" />
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Controls.Input name="lastResponseCode" label="Last Response Code" />
                </Grid>
              </Grid>
              {/* <Grid item xs={8} container spacing={2} justifyContent="center" alignItems="center">
                <Controls.Button>Submit Bank</Controls.Button>
              </Grid> */}
              <Grid margin={2} container direction="row" justifyContent="right" alignItems="right">
                <Grid item xs={12} sm={1} marginRight={1}>
                  <Controls.Button type="submit" variant="contained" startIcon={<SaveIcon />}>
                    Save...
                  </Controls.Button>
                </Grid>
                <Grid item xs={12} sm={1}>
                  <Button
                    variant="outlined"
                    startIcon={<UpdateIcon />}
                    // onClick={() => handleNewClient()}
                  >
                    Update
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </CardContent>
    </Card>
  );
}
